import { useRef } from "react";

import { OnboardingV2AnalyticsPageView } from "@/constants/analytics/Analytics";
import { OnboardingV2TestID } from "@/constants/TestID";
import useOnboardingSplashScreenVisibility from "@/hooks/onboarding/useOnboardingSplashScreenVisibility";
import useScreenViewAnalytics from "@/hooks/useScreenViewAnalytics";
import { useGetBasicInfoQuery } from "@/store/api/user";
import { OnboardingContent } from "@/ui/components/onboarding/v2/OnboardingContent";
import { OnboardingSplashScreen } from "@/ui/components/onboarding/v2/OnboardingSplashScreen";
import { VStack } from "@/ui/layout";
import RadialGradientBackground from "@/ui/layout/RadialGradientBackground";
import { LayoutToken } from "@/ui/theme/tokens";
import { getPreferredFirstName } from "@/utils/user.util";

const Screen = () => {
  const { data: basicInfoData } = useGetBasicInfoQuery();
  const { isSplashVisible, markSplashAsSeen } =
    useOnboardingSplashScreenVisibility();
  const didShowSplash = useRef(isSplashVisible);

  const name = getPreferredFirstName({
    chosenName: basicInfoData?.chosenName,
    firstName: basicInfoData?.firstName ?? "",
  });

  useScreenViewAnalytics({ screenName: OnboardingV2AnalyticsPageView.Modal });

  return (
    <RadialGradientBackground testID={OnboardingV2TestID.Primary}>
      <VStack
        alignItems="center"
        alignSelf="center"
        flex={1}
        maxWidth={LayoutToken.WebContentMaxWidth}
        width="100%"
      >
        {isSplashVisible ? (
          <OnboardingSplashScreen
            appUser={name}
            onContinuePress={markSplashAsSeen}
          />
        ) : (
          <OnboardingContent shouldAnimateEntrance={didShowSplash.current} />
        )}
      </VStack>
    </RadialGradientBackground>
  );
};

// eslint-disable-next-line import-x/no-unused-modules -- Modal/Tab/TabLayout/Screen/Home get used in expo routing but in a way that TypeScript can not infer
export default Screen;
